export default ({ request }) => ({
  tcOrderInfoListApi(data = {}) {
    return request({
      url: '/factory/tc/order/info/list',
      method: 'post',
      data,
    })
  },
  tcOrderInfoDetailApi(data = {}) {
    return request({
      url: '/factory/tc/order/info/detail',
      method: 'post',
      data,
    })
  },
  tcOrderInfoAddApi(data = {}) {
    return request({
      url: '/factory/tc/order/info/add',
      method: 'post',
      data,
    })
  },
  tcOrderInfoUpdateApi(data = {}) {
    return request({
      url: '/factory/tc/order/info/update',
      method: 'post',
      data,
    })
  },
  tcOrderInfoDelApi(data = {}) {
    return request({
      url: '/factory/tc/order/info/del',
      method: 'post',
      data,
    })
  },
  tcOrderInfoReviewApi(data = {}) {
    return request({
      url: '/factory/tc/order/info/review',
      method: 'post',
      data,
    })
  },
  tcOrderInfoExportCheckApi(data = {}) {
    return request({
      url: '/factory/tc/order/info/exportCheck',
      method: 'post',
      data,
    })
  },
  tcOrderGoodsListApi(data = {}) {
    return request({
      url: '/factory/tc/order/goods/list',
      method: 'post',
      data,
    })
  },
  tcOrderGoodsDetailApi(data = {}) {
    return request({
      url: '/factory/tc/order/goods/detail',
      method: 'post',
      data,
    })
  },
  tcOrderGoodsSelectImageApi(data = {}) {
    return request({
      url: '/factory/tc/order/goods/selectImage',
      method: 'post',
      data,
    })
  },
  tcOrderGoodsUpdateApi(data = {}) {
    return request({
      url: '/factory/tc/order/goods/update',
      method: 'post',
      data,
    })
  },
  tcOrderGoodsSpecListApi(data = {}) {
    return request({
      url: '/factory/tc/order/goods/spec/list',
      method: 'post',
      data,
    })
  },
})
